import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import OrderDetails from "../pages/OrderDetails";
import { paths } from "./paths";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route exact path={paths.home} element={<Home />} />
        <Route exact path={paths.orderDetails} element={<OrderDetails />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
